import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LandingPage from "./pages/landing/LandingPage";
import ChatbotPage from "./ChatbotPage";
import AuthPage from "./AuthPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileUploadProvider } from "./features/file_upload/FileUploadUpdated";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === "true";
  });
  const [userName, setUserName] = useState(
    () => localStorage.getItem("userName") || "",
  );
  const [userId, setUserId] = useState(
    () => localStorage.getItem("userId") || "",
  );

  useEffect(() => {
    document.title = "DATAGENX";
  }, []);

  const handleLoginSuccess = (name, id) => {
    setUserName(name);
    setUserId(id);
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("userName", name);
    localStorage.setItem("userId", id);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserName("");
    setUserId("");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userName");
    localStorage.removeItem("userId");
    localStorage.removeItem("platform");
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/chat"
          element={
            isAuthenticated ? (
              <FileUploadProvider>
                <ChatbotPage
                  userName={userName}
                  userId={userId}
                  onLogout={handleLogout}
                />
              </FileUploadProvider>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/chat" />
            ) : (
              <AuthPage onLogin={handleLoginSuccess} />
            )
          }
        />
        <Route
          path="/register"
          element={
            isAuthenticated ? (
              <Navigate to="/chat" />
            ) : (
              <AuthPage onLogin={handleLoginSuccess} />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999999,
          fontSize: "14px",
        }}
      />
    </Router>
  );
}

export default App;
